import { TodoInputBlock } from '@coast/schemas';
import { View } from '@shared/components/View';
import { TodoItem } from '@shared/components/blocks/types';
import { MBBlockLabel } from '@shared/components/blocks/utils/label';
import { i18n } from '@shared/util/i18n';

interface CompressedTodoBlockProps {
  block: TodoInputBlock;
  todos: TodoItem[];
}

export function CompressedTodoBlock({ block, todos }: CompressedTodoBlockProps) {
  return (
    <View paddingHorizontal={3} paddingTop={1}>
      <MBBlockLabel
        label={
          !todos?.length
            ? block.label
            : i18n('card.blocks.todoInput.label', {
                label: block.label,
                totalCount: todos.length,
                completedCount: todos.filter((item: TodoItem) => item.status === 'COMPLETED')
                  .length,
              })
        }
      />
    </View>
  );
}
